@if (availableColumns && model_dict) {
  <div class="row column-selector">
    <div class="draggable-list-container">
      <h2>Selected Columns</h2>
      <option-list-search
          [placeholder]="'Search columns'"
          (inputChanged)="selectedColumnFilterValue=$event"
          (inputCleared)="selectedColumnFilterValue=''"
          data-testid="selected-columns-search"
      ></option-list-search>
      <div
          id="selectedList"
          #selectedList="cdkDropList"
          (cdkDropListDropped)="drop($event)"
          [cdkDropListConnectedTo]="availableLists"
          [cdkDropListData]="selectedColumns"
          cdkDropList
          class="draggable-list">

        @for (column of selectedColumns | filterByValue: columnFilter.bind(this) : selectedColumnFilterValue; track (column.related_type_id ?? '') + ':' + column.id) {
          <div
              cdkDrag [cdkDragData]="column" class="draggable-list-item"
              style="display:flex; justify-content: space-between;" [ngClass]="{'wrap-field-item': fitHeight(column.id)}">
            <div [ngStyle]="{'font-weight':column.format?.bold? 'bold' : '',
            'font-style':column.format?.italic? 'italic' : '',
            'font-size': column.format?.size ? column.format.size + '%' : '100%'}"
                 class="column-name" cdkDragHandle
                 [dblClickCopy]="model_dict[column.id]?.attributes.name || column.title">
              <div>
                @if (column.related_type_id) {
                  <span class="parent-prefix">
                  {{componentTypeDict?.[column.related_type_id]?.attributes.name || 'Related property'}}:</span>
                }
                {{(model_dict[column.id]?.attributes.name || column.title || column.id) | upperfirst}}
              </div>
            </div>
            <div class="column-title">
              <input [(ngModel)]="column.title"
                     (mousedown)="$event.stopPropagation()"
                     matInput
                     placeholder="Column name"
                     name="Column name" style="width: auto; max-width:100%;"/>
            </div>
            @if (allowDefaults) {
              <default-value-field
                  [defaultField]="column"
                  [constantProperty]="getConstantProperty(column.id)"
                  [componentType]="getComponentType(column.id)"
                  [firstComponentType]="parentComponentType"
                  [panelClass]="panelClass"
                  class="default-value-field">
              </default-value-field>
            }
            <div style="display: flex; justify-content: right;">
              <div style="display: flex; align-items: center;">
                @if (colMenuOptions?.length) {
                  <div style="margin-left:10px;">
                    <button [matMenuTriggerFor]="columnMenu" class="formatting-button" mat-button
                            matTooltip="Format column" matTooltipPosition="above"
                            style="margin:0;background-color:#8b8c8e;" type="button">
                      <i class="fa fa-bars"></i>
                    </button>
                    <mat-menu #columnMenu="matMenu" class="column-menu dark series-formatting-menu">
                      <table-column-menu [item]="column.format"
                                         [options]="colMenuOptions"
                                         [dataType]="getColumnDataType(column)"
                                         (formatsChanged)="column.format = $event;formatsChanged($event)"
                                         [default_values]="default_format_values">
                      </table-column-menu>
                    </mat-menu>
                  </div>
                }
                <button class="move" type="button" (click)="moveColumn('remove', column)" mat-button>
                  <i class="fa fa-caret-right"></i></button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="column" style="margin:50px 0 0 0;cursor:pointer;">
      <i (click)="moveColumns('select')"
         class="fas fa-angle-double-left" matTooltip="Select all available columns"
         data-testid="Select all available columns"
         style="padding:10px;border: 1px solid #ccc;border-radius: 4px;margin-bottom:10px;"></i>
      <i (click)="moveColumns('remove')"
         class="fas fa-angle-double-right" matTooltip="Remove all selected columns"
         data-testid="remove all selected columns"
         style="padding:10px;border: 1px solid #ccc;border-radius: 4px;"></i>
    </div>

    <div class="draggable-list-container">
      <h2>Available Columns</h2>
      <option-list-search
          [placeholder]="'Search columns'"
          (inputChanged)="availableColumnFilterValue=$event"
          (inputCleared)="availableColumnFilterValue=''"
          data-testid="available-columns-search"
      ></option-list-search>

      <div class="available-options-container draggable-list">

        <h4 (click)="toggleColumnOptions('availableList')"
            [matTooltip]="'Show/hide ' + (parentName ?? 'standard') + ' column options'">
          <div>
              <span
                  class="material-symbols-outlined arrow">{{expandedColumnOptions['availableList'] ? 'arrow_drop_down' : 'arrow_right'}}</span>
            {{parentComponentType?.attributes.name ?? 'Standard'}} column options
          </div>
        </h4>
        <ng-container [ngTemplateOutlet]="availableDropList"
                      [ngTemplateOutletContext]="{ $implicit: availableColumns, id: 'availableList' }">
        </ng-container>

        @for (componentType of relatedComponentTypes; track componentType) {
          <h4 (click)="toggleColumnOptions(componentType.id)">
            <div [matTooltip]="'Show/hide ' + componentType.attributes.name + ' properties'">
                <span
                    class="material-symbols-outlined arrow">{{expandedColumnOptions[componentType.id] ? 'arrow_drop_down' : 'arrow_right'}}</span>
              {{componentType.attributes.name}}
            </div>
          </h4>
          @if (expandedColumnOptions[componentType.id]) {
            @if (!propertiesLoadingDict[componentType.id]) {
              <ng-container [ngTemplateOutlet]="availableDropList"
                            [ngTemplateOutletContext]="{ $implicit: filteredCTPropertyDict[componentType.id], id: componentType.id }">
              </ng-container>
            } @else {
              <div class="stage">
                <div class="dot-flashing"></div>
              </div>
            }
          }
        }

        <ng-template #availableDropList let-available let-id="id">
          <div
              [id]="id"
              #CTAvailableList="cdkDropList"
              (cdkDropListDropped)="drop($event)"
              [cdkDropListConnectedTo]="[selectedList]"
              [cdkDropListData]="available"
              cdkDropList
              [style.display]="expandedColumnOptions[id] ? 'block' : 'none'">
            @for (column of available | filterByValue: columnFilter.bind(this) : availableColumnFilterValue; track column.id) {
              <div
                  cdkDrag
                  [cdkDragData]="column"
                  class="draggable-list-item"
                  style="display:flex; justify-content: space-between;"
                  [dblClickCopy]="model_dict[column.id]?.attributes.name || column.id">
                <div class="row center">
                  <button class="move" type="button" (click)="moveColumn('select', column, id)" mat-button>
                    <i class="fa fa-caret-left"></i></button>
                  <div
                      [matTooltip]="model_dict[column.id]?.attributes?.description || model_dict[column.id]?.attributes?.name"
                      [matTooltipShowDelay]="TOOLTIP_SHOW_DELAY"
                      [matTooltipDisabled]="!model_dict[column.id]?.attributes?.description && !model_dict[column.id]?.attributes?.name">
                    {{model_dict[column.id]?.attributes.name || column.id | upperfirst}}
                  </div>
                </div>
                @if (!column.type?.includes('attribute')) {
                  <div style="text-align:right;">
                    ({{column.type | removeUnderscore | upperfirst}}
                    @if (isConstantProperty(model_dict[column.id]) && model_dict[column.id]?.attributes.is_calculation) {
                      <span
                      >, calculation</span>
                    }
                    <span>)</span>
                  </div>
                }
              </div>
            }
          </div>
        </ng-template>
      </div>

    </div>
  </div>
} @else {
  <div class="stage">
    <div class="dot-flashing"></div>
  </div>
}
